/**
 * @generated SignedSource<<18b6e2c9a478a06649545ac1e980eed4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationTilTidCreateScreenMutation$variables = {
  customerId: string;
  unitId?: string | null;
};
export type IntegrationTilTidCreateScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationTilTid: {
      readonly id: string;
      readonly name: string | null;
    } | null;
  };
};
export type IntegrationTilTidCreateScreenMutation = {
  response: IntegrationTilTidCreateScreenMutation$data;
  variables: IntegrationTilTidCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unitId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "customerId",
            "variableName": "customerId"
          },
          {
            "kind": "Variable",
            "name": "unitId",
            "variableName": "unitId"
          }
        ],
        "concreteType": "IntegrationTilTid",
        "kind": "LinkedField",
        "name": "activateIntegrationTilTid",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationTilTidCreateScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationTilTidCreateScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "af923d9600fcd703145de96120a4746f",
    "id": null,
    "metadata": {},
    "name": "IntegrationTilTidCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationTilTidCreateScreenMutation(\n  $customerId: String!\n  $unitId: String\n) {\n  store {\n    activateIntegrationTilTid(customerId: $customerId, unitId: $unitId) {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "67fac5ceba8b001dc7b4ccca9c5cdd48";

export default node;
